var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",class:[_vm.size, { rounded: _vm.rounded }, { circle: _vm.circle }, { fill: _vm.fill }, _vm.color, _vm.customClass]},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }